<template>
  <div>
    <v-data-table
      :loading="loadingTable"
      :headers="headers"
      :items="logs"
      class="elevation-1"
      :page-count="numberOfPagesPaginate"
      :page="currentPagePaginate"
      :server-items-length="totalStagesPaginate"
      :options.sync="options"
      :footer-props="{
        itemsPerPageText: 'Itens por página',
        itemsPerPageOptions: [5, 10, 15],
        showFirstLastPage: true,
      }"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Histórico Reservas</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <v-text-field
            :append-icon="icons.mdiMagnify"
            class="mt-6"
            dense
            rounded
            outlined
            label="Pesquisar"
            v-model="search"
            @click:append="confirmSearch()"
            placeholder="Nome da reserva"
            @keyup.enter="confirmSearch()"
          ></v-text-field>

          <v-spacer></v-spacer>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          color="primary"
          small
          @click="openLogs(item)"
        >
          Ver detalhes
        </v-btn>
      </template>
    </v-data-table>

    <!-- Modal de detalhes -->
    <v-dialog
      v-if="selectedLog"
      v-model="dialogLogs"
      max-width="1000px"
      scrollable
    >
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon
            left
            color="white"
          >
            {{ icons.mdiFileDocumentOutline }}
          </v-icon>
          <span class="text-h5 white--text">Reserva #{{ selectedLog.reserve_id ? selectedLog.reserve_id : '-' }}</span>
          <v-spacer></v-spacer>
          <v-chip
            small
            outlined
            color="white"
            class="white--text"
          >
            <v-icon
              left
              small
              color="white"
            >
              {{ icons.mdiCalendar }}
            </v-icon>
            {{ selectedLog.created_at }}
          </v-chip>
        </v-card-title>

        <v-card-text class="pa-4">
          <v-expansion-panels multiple>
            <!-- Reserva -->
            <v-expansion-panel v-if="selectedLog.reserve && selectedLog.reserve.length">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-icon
                    left
                    color="info"
                  >
                    {{ icons.mdiBookmark }}
                  </v-icon>
                  <span class="font-weight-bold">Reserva</span>
                  <v-chip
                    x-small
                    class="ml-2"
                    color="info"
                    dark
                  >
                    {{ selectedLog.reserve.length }}
                  </v-chip>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-timeline
                  dense
                  class="custom-timeline"
                >
                  <v-timeline-item
                    v-for="(item, i) in selectedLog.reserve"
                    :key="i"
                    :color="getColor(item.action)"
                    small
                  >
                    <v-card
                      class="elevation-2 timeline-card"
                      outlined
                    >
                      <v-card-subtitle class="pb-1 pt-2">
                        <v-chip
                          x-small
                          :color="getColor(item.action)"
                          dark
                        >
                          {{ translateAction(item.action) }}
                        </v-chip>
                        <v-chip
                          x-small
                          outlined
                          class="ml-2"
                        >
                          <v-icon
                            x-small
                            left
                          >
                            {{ icons.mdiCalendar }}
                          </v-icon>
                          {{ formatDate(item.date) }}
                        </v-chip>
                      </v-card-subtitle>
                      <v-card-text class="pt-2">
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiAccount }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Usuário:</span>
                          <strong class="ml-1">{{ item.user && item.user.name ? item.user.name : 'Sistema' }}</strong>
                        </div>
                        <div
                          v-if="item.attribute"
                          class="info-row"
                        >
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiLabel }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Atributo:</span>
                          <strong class="ml-1">{{ item.attribute }}</strong>
                        </div>
                        <div
                          v-if="item.old_value"
                          class="info-row"
                        >
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiArrowLeft }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Antes:</span>
                          <span class="ml-1">{{ item.old_value }}</span>
                        </div>
                        <div
                          v-if="item.new_value"
                          class="info-row"
                        >
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiArrowRight }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Depois:</span>
                          <span class="ml-1">{{ item.new_value }}</span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Acomodação -->
            <v-expansion-panel v-if="selectedLog.accommodation && selectedLog.accommodation.length">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-icon
                    left
                    color="indigo"
                  >
                    {{ icons.mdiDoorOpen }}
                  </v-icon>
                  <span class="font-weight-bold">Acomodação</span>
                  <v-chip
                    x-small
                    class="ml-2"
                    color="indigo"
                    dark
                  >
                    {{ selectedLog.accommodation.length }}
                  </v-chip>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-timeline
                  dense
                  class="custom-timeline"
                >
                  <v-timeline-item
                    v-for="(item, i) in selectedLog.accommodation"
                    :key="i"
                    :color="getColor(item.action)"
                    small
                  >
                    <v-card
                      class="elevation-2 timeline-card"
                      outlined
                    >
                      <v-card-subtitle class="pb-1 pt-2">
                        <v-chip
                          x-small
                          :color="getColor(item.action)"
                          dark
                        >
                          {{ translateAction(item.action) }}
                        </v-chip>
                        <v-chip
                          x-small
                          outlined
                          class="ml-2"
                        >
                          <v-icon
                            x-small
                            left
                          >
                            {{ icons.mdiCalendar }}
                          </v-icon>
                          {{ formatDate(item.date) }}
                        </v-chip>
                      </v-card-subtitle>
                      <v-card-text class="pt-2">
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiAccount }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Usuário:</span>
                          <strong class="ml-1">{{ item.user ? item.user : 'Sistema' }}</strong>
                        </div>
                        <div
                          v-if="item.description"
                          class="info-row"
                        >
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiInformation }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Descrição:</span>
                          <span class="ml-1">{{ item.description }}</span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Diárias -->
            <v-expansion-panel v-if="selectedLog.accommodation_items && selectedLog.accommodation_items.length">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-icon
                    left
                    color="success"
                  >
                    {{ icons.mdiBed }}
                  </v-icon>
                  <span class="font-weight-bold">Diárias</span>
                  <v-chip
                    x-small
                    class="ml-2"
                    color="success"
                    dark
                  >
                    {{ selectedLog.accommodation_items.length }}
                  </v-chip>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-timeline
                  dense
                  class="custom-timeline"
                >
                  <v-timeline-item
                    v-for="(item, i) in selectedLog.accommodation_items"
                    :key="i"
                    :color="getColor(item.action)"
                    small
                  >
                    <v-card
                      class="elevation-2 timeline-card"
                      outlined
                    >
                      <v-card-subtitle class="pb-1 pt-2">
                        <v-chip
                          x-small
                          :color="getColor(item.action)"
                          dark
                        >
                          {{ item.action }}
                        </v-chip>
                        <v-chip
                          x-small
                          outlined
                          class="ml-2"
                        >
                          <v-icon
                            x-small
                            left
                          >
                            {{ icons.mdiCalendar }}
                          </v-icon>
                          {{ formatDate(item.date) }}
                        </v-chip>
                      </v-card-subtitle>
                      <v-card-text class="pt-2">
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiAccount }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Usuário:</span>
                          <strong class="ml-1">{{ item.user ? item.user : 'Sistema' }}</strong>
                        </div>
                        <div
                          v-if="item.attribute"
                          class="info-row"
                        >
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiLabel }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Atributo:</span>
                          <strong class="ml-1">{{ item.attribute }}</strong>
                        </div>
                        <div
                          v-if="item.old_value"
                          class="info-row"
                        >
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiArrowLeft }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Antes:</span>
                          <span class="ml-1">{{ item.old_value }}</span>
                        </div>
                        <div
                          v-if="item.new_value"
                          class="info-row"
                        >
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiArrowRight }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Depois:</span>
                          <span class="ml-1">{{ item.new_value }}</span>
                        </div>
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiCurrencyUsd }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Valor:</span>
                          <strong class="ml-1 green--text">{{ formatMoney(item.value) }}</strong>
                        </div>
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiCalendarRange }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Período:</span>
                          <span class="ml-1">{{ item.date_start }} a {{ item.date_end }}</span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Tarifas Extras -->
            <v-expansion-panel v-if="selectedLog.accommodation_extra_items && selectedLog.accommodation_extra_items.length">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-icon
                    left
                    color="orange"
                  >
                    {{ icons.mdiTagMultiple }}
                  </v-icon>
                  <span class="font-weight-bold">Tarifas Extras</span>
                  <v-chip
                    x-small
                    class="ml-2"
                    color="orange"
                    dark
                  >
                    {{ selectedLog.accommodation_extra_items.length }}
                  </v-chip>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-timeline
                  dense
                  class="custom-timeline"
                >
                  <v-timeline-item
                    v-for="(item, i) in selectedLog.accommodation_extra_items"
                    :key="i"
                    :color="getColor(item.action)"
                    small
                  >
                    <v-card
                      class="elevation-2 timeline-card"
                      outlined
                    >
                      <v-card-subtitle class="pb-1 pt-2">
                        <v-chip
                          x-small
                          :color="getColor(item.action)"
                          dark
                        >
                          {{ item.action }}
                        </v-chip>
                        <v-chip
                          x-small
                          :color="item.type === 'Desconto' ? 'red' : 'orange'"
                          class="ml-2"
                          outlined
                        >
                          {{ item.type }}
                        </v-chip>
                        <v-chip
                          x-small
                          outlined
                          class="ml-2"
                        >
                          <v-icon
                            x-small
                            left
                          >
                            {{ icons.mdiCalendar }}
                          </v-icon>
                          {{ formatDate(item.date) }}
                        </v-chip>
                      </v-card-subtitle>
                      <v-card-text class="pt-2">
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiAccount }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Usuário:</span>
                          <strong class="ml-1">{{ item.user ? item.user : 'Sistema' }}</strong>
                        </div>
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiTextBox }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Descrição:</span>
                          <span class="ml-1">{{ item.description ? item.description : '-' }}</span>
                        </div>
                        <div
                          v-if="item.attribute"
                          class="info-row"
                        >
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiLabel }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Atributo:</span>
                          <strong class="ml-1">{{ item.attribute }}</strong>
                        </div>
                        <div
                          v-if="item.old_value"
                          class="info-row"
                        >
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiArrowLeft }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Antes:</span>
                          <span class="ml-1">{{ item.old_value }}</span>
                        </div>
                        <div
                          v-if="item.new_value"
                          class="info-row"
                        >
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiArrowRight }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Depois:</span>
                          <span class="ml-1">{{ item.new_value }}</span>
                        </div>
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiCurrencyUsd }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Valor:</span>
                          <strong
                            class="ml-1"
                            :class="item.type === 'Desconto' ? 'red--text' : 'orange--text'"
                          >
                            {{ formatMoney(item.value) }}
                          </strong>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Consumos -->
            <v-expansion-panel v-if="selectedLog.posted_items && selectedLog.posted_items.length">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-icon
                    left
                    color="indigo"
                  >
                    {{ icons.mdiSilverwareVariant }}
                  </v-icon>
                  <span class="font-weight-bold">Consumos</span>
                  <v-chip
                    x-small
                    class="ml-2"
                    color="indigo"
                    dark
                  >
                    {{ selectedLog.posted_items.length }}
                  </v-chip>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-timeline
                  dense
                  class="custom-timeline"
                >
                  <v-timeline-item
                    v-for="(item, i) in selectedLog.posted_items"
                    :key="i"
                    :color="getColor(item.action)"
                    small
                  >
                    <v-card
                      class="elevation-2 timeline-card"
                      outlined
                    >
                      <v-card-subtitle class="pb-1 pt-2">
                        <v-chip
                          x-small
                          :color="getColor(item.action)"
                          dark
                        >
                          {{ translateAction(item.action) }}
                        </v-chip>
                        <v-chip
                          x-small
                          outlined
                          class="ml-2"
                        >
                          <v-icon
                            x-small
                            left
                          >
                            {{ icons.mdiCalendar }}
                          </v-icon>
                          {{ formatDate(item.date) }}
                        </v-chip>
                      </v-card-subtitle>
                      <v-card-text class="pt-2">
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiAccount }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Usuário:</span>
                          <strong class="ml-1">{{ item.user ? item.user : 'Sistema' }}</strong>
                        </div>
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiTextBox }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Descrição:</span>
                          <span class="ml-1">{{ item.description ? item.description : '-' }}</span>
                        </div>
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiCounter }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Quantidade:</span>
                          <strong class="ml-1">{{ item.quantity || 0 }}</strong>
                        </div>
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiCurrencyUsd }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Valor Unitário:</span>
                          <strong class="ml-1 blue--text">{{ formatMoney(item.value) }}</strong>
                        </div>
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiCalculator }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Total:</span>
                          <strong class="ml-1 green--text text--darken-2">{{ formatMoney((item.quantity || 0) * (item.value || 0)) }}</strong>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Transferências de Itens -->
            <v-expansion-panel v-if="selectedLog.transf_itens && selectedLog.transf_itens.length">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-icon
                    left
                    color="teal"
                  >
                    {{ icons.mdiSwapHorizontal }}
                  </v-icon>
                  <span class="font-weight-bold">Transferências de Itens</span>
                  <v-chip
                    x-small
                    class="ml-2"
                    color="teal"
                    dark
                  >
                    {{ selectedLog.transf_itens.length }}
                  </v-chip>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-timeline
                  dense
                  class="custom-timeline"
                >
                  <v-timeline-item
                    v-for="(item, i) in selectedLog.transf_itens"
                    :key="i"
                    :color="getColor(item.action)"
                    small
                  >
                    <v-card
                      class="elevation-2 timeline-card"
                      outlined
                    >
                      <v-card-subtitle class="pb-1 pt-2">
                        <v-chip
                          x-small
                          :color="getColor(item.action)"
                          dark
                        >
                          {{ item.action }}
                        </v-chip>
                        <v-chip
                          x-small
                          outlined
                          class="ml-2"
                        >
                          <v-icon
                            x-small
                            left
                          >
                            {{ icons.mdiCalendar }}
                          </v-icon>
                          {{ formatDate(item.date) }}
                        </v-chip>
                      </v-card-subtitle>
                      <v-card-text class="pt-2">
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiAccount }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Usuário:</span>
                          <strong class="ml-1">{{ item.user ? item.user : 'Sistema' }}</strong>
                        </div>
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiTextBox }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Descrição:</span>
                          <span class="ml-1">{{ item.description || '-' }}</span>
                        </div>
                        <div
                          v-if="item.old_value"
                          class="info-row"
                        >
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiArrowLeft }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Origem:</span>
                          <span class="ml-1">{{ item.old_value }}</span>
                        </div>
                        <div
                          v-if="item.new_value"
                          class="info-row"
                        >
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiArrowRight }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Destino:</span>
                          <span class="ml-1">{{ item.new_value }}</span>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Pagamentos -->
            <v-expansion-panel v-if="selectedLog.payments && selectedLog.payments.length">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-icon
                    left
                    color="purple"
                  >
                    {{ icons.mdiCashMultiple }}
                  </v-icon>
                  <span class="font-weight-bold">Pagamentos</span>
                  <v-chip
                    x-small
                    class="ml-2"
                    color="purple"
                    dark
                  >
                    {{ selectedLog.payments.length }}
                  </v-chip>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-timeline
                  dense
                  class="custom-timeline"
                >
                  <v-timeline-item
                    v-for="(item, i) in selectedLog.payments"
                    :key="i"
                    :color="getColor(item.action)"
                    small
                  >
                    <v-card
                      class="elevation-2 timeline-card"
                      outlined
                    >
                      <v-card-subtitle class="pb-1 pt-2">
                        <v-chip
                          x-small
                          :color="getColor(item.action)"
                          dark
                        >
                          {{ translateAction(item.action) }}
                        </v-chip>
                        <v-chip
                          x-small
                          outlined
                          class="ml-2"
                        >
                          <v-icon
                            x-small
                            left
                          >
                            {{ icons.mdiCalendar }}
                          </v-icon>
                          {{ formatDate(item.date) }}
                        </v-chip>
                      </v-card-subtitle>
                      <v-card-text class="pt-2">
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiAccount }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Usuário:</span>
                          <strong class="ml-1">{{ item.user ? item.user : 'Sistema' }}</strong>
                        </div>
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiCreditCard }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Método:</span>
                          <strong class="ml-1">{{ item.method ? item.method : '-' }}</strong>
                        </div>
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiCurrencyUsd }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Valor:</span>
                          <strong class="ml-1 purple--text text--darken-2">{{ formatMoney(item.value) }}</strong>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-expansion-panel-content>
            </v-expansion-panel>

            <!-- Checkout -->
            <v-expansion-panel v-if="selectedLog.checkout">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-icon
                    left
                    color="success"
                  >
                    {{ icons.mdiCheckCircle }}
                  </v-icon>
                  <span class="font-weight-bold text-success">Checkout</span>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-timeline
                  dense
                  class="custom-timeline"
                >
                  <v-timeline-item
                    color="success"
                    small
                  >
                    <v-card
                      class="elevation-2 timeline-card"
                      outlined
                    >
                      <v-card-subtitle class="pb-1 pt-2">
                        <v-chip
                          x-small
                          color="success"
                          dark
                        >
                          <v-icon
                            x-small
                            left
                          >
                            {{ icons.mdiCheckCircle }}
                          </v-icon>
                          Checkout realizado
                        </v-chip>
                        <v-chip
                          x-small
                          outlined
                          class="ml-2"
                        >
                          <v-icon
                            x-small
                            left
                          >
                            {{ icons.mdiCalendar }}
                          </v-icon>
                          {{ formatDate(selectedLog.checkout.date) }}
                        </v-chip>
                      </v-card-subtitle>
                      <v-card-text class="pt-2">
                        <div class="info-row">
                          <v-icon
                            small
                            class="mr-2"
                          >
                            {{ icons.mdiAccount }}
                          </v-icon>
                          <span class="grey--text text--darken-1">Usuário:</span>
                          <strong class="ml-1">{{ selectedLog.checkout.user || 'Sistema' }}</strong>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>

        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red"
            text
            @click="dialogLogs = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiMagnify,
  mdiFileDocumentOutline,
  mdiCalendar,
  mdiBookmark,
  mdiBed,
  mdiTagMultiple,
  mdiCashMultiple,
  mdiAccount,
  mdiLabel,
  mdiArrowLeft,
  mdiArrowRight,
  mdiDoorOpen,
  mdiInformation,
  mdiCurrencyUsd,
  mdiCalendarRange,
  mdiTextBox,
  mdiCounter,
  mdiCalculator,
  mdiSilverwareVariant,
  mdiCreditCard,
  mdiCheckCircle,
  mdiSwapHorizontal,
} from '@mdi/js'
import { mapActions } from 'vuex'
import NoDataTable from '@/components/NoDataTable.vue'

export default {
  components: { NoDataTable },
  data: () => ({
    search: '',
    loadingTable: false,
    totalStagesPaginate: 0,
    numberOfPagesPaginate: 0,
    currentPagePaginate: 0,
    dialogLogs: false,
    selectedLog: null,
    headers: [
      { text: 'ID', align: 'start', value: 'reserve_id' },
      { text: 'USUÁRIO', value: 'user' },
      { text: 'CRIADO EM', value: 'created_at' },
      {
        text: '', align: 'center', value: 'actions', sortable: false,
      },
    ],
    logs: [],
    options: {},
    icons: {
      mdiMagnify,
      mdiFileDocumentOutline,
      mdiCalendar,
      mdiBookmark,
      mdiBed,
      mdiTagMultiple,
      mdiCashMultiple,
      mdiAccount,
      mdiLabel,
      mdiArrowLeft,
      mdiArrowRight,
      mdiDoorOpen,
      mdiInformation,
      mdiCurrencyUsd,
      mdiCalendarRange,
      mdiTextBox,
      mdiCounter,
      mdiCalculator,
      mdiSilverwareVariant,
      mdiCreditCard,
      mdiCheckCircle,
      mdiSwapHorizontal,
    },
  }),
  watch: {
    options: { handler() { this.initialize() } },
  },
  created() { this.initialize() },
  methods: {
    ...mapActions('logs', ['getReservesLogs']),

    initialize() {
      this.loadingTable = true
      const { page, itemsPerPage } = this.options
      const payload = { itemsPerPage: itemsPerPage || 10, page, search: this.search }

      this.getReservesLogs(payload)
        .then(response => {
          this.logs = response.data.data.map(log => ({
            reserve: log.reserve || [],
            accommodation: log.accommodation || [],
            accommodation_items: log.accommodation_items || [],
            accommodation_extra_items: log.accommodation_extra_items || [],
            posted_items: log.posted_items || [],
            payments: log.payments || [],
            transf_itens: log.transf_itens || [],
            ...log,
          }))
          this.totalStagesPaginate = response.data.meta.total
          this.numberOfPagesPaginate = response.data.meta.last_page
          this.currentPagePaginate = response.data.meta.current_page
        })
        .finally(() => { this.loadingTable = false })
    },

    confirmSearch() { this.initialize() },

    openLogs(item) {
      this.selectedLog = item
      this.dialogLogs = true
    },

    getColor(action) {
      if (!action) return 'grey'

      const actionLower = action.toLowerCase().trim()

      // Check-in
      if (actionLower.includes('check-in')) return 'success'

      // Transferências de itens (DEVE vir antes de "transferência" genérico)
      if (actionLower.includes('itens') && (actionLower.includes('transferencia') || actionLower.includes('transferência'))) {
        return 'teal'
      }

      // Transferência de quarto
      if (actionLower.includes('transferencia') || actionLower.includes('transferência')) return 'warning'

      // Avulsa
      if (actionLower.includes('avulsa')) return 'purple'

      // Diárias
      if ((actionLower.includes('diaria') || actionLower.includes('diária')) && actionLower.includes('criada')) {
        return 'success'
      }
      if ((actionLower.includes('diaria') || actionLower.includes('diária')) && actionLower.includes('atualizada')) {
        return 'warning'
      }
      if ((actionLower.includes('diaria') || actionLower.includes('diária')) && actionLower.includes('removida')) {
        return 'error'
      }

      // Tarifas Extras
      if (actionLower.includes('tarifa extra') && actionLower.includes('criada')) return 'orange'
      if (actionLower.includes('tarifa extra') && actionLower.includes('atualizada')) return 'orange darken-2'
      if (actionLower.includes('tarifa extra') && actionLower.includes('removida')) return 'error'

      // Consumos (mais específico primeiro)
      if (actionLower.includes('estornou') && actionLower.includes('consumo')) return 'error'
      if ((actionLower.includes('lançamento') || actionLower.includes('lancamento')) && actionLower.includes('consumo')) {
        return 'success'
      }

      // Pagamentos
      if (actionLower.includes('pagamento') && (actionLower.includes('lançado') || actionLower.includes('lancado'))) {
        return 'purple'
      }
      if (actionLower.includes('pagamento') && actionLower.includes('removido')) return 'error'

      // Checkout
      if (actionLower.includes('checkout')) return 'success'

      // Ações genéricas (por último)
      if (actionLower === 'created' || actionLower === 'criado') return 'success'
      if (actionLower === 'update' || actionLower === 'atualizado') return 'info'
      if (actionLower === 'deleted' || actionLower === 'removido') return 'error'

      return 'grey'
    },

    translateAction(action) {
      const map = {
        created: 'Criado',
        update: 'Atualizado',
        deleted: 'Removido',
      }

      return map[action] || action
    },

    formatDate(date) {
      if (!date) return '-'
      try {
        // Se já vier no formato brasileiro (dd/mm/yyyy HH:mm:ss), converte para ISO
        if (typeof date === 'string' && date.match(/^\d{2}\/\d{2}\/\d{4}/)) {
          const parts = date.split(' ')
          const datePart = parts[0].split('/')
          const timePart = parts[1] || '00:00:00'

          // Converte de dd/mm/yyyy para yyyy-mm-dd
          const isoDate = `${datePart[2]}-${datePart[1]}-${datePart[0]}T${timePart}`
          const d = new Date(isoDate)
          if (!isNaN(d.getTime())) {
            return d.toLocaleString('pt-BR', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
            })
          }
        }

        // Tenta outras formas de conversão
        const cleanDate = date.toString().endsWith('Z') ? date.slice(0, -1) : date
        const d = new Date(cleanDate)
        if (!isNaN(d.getTime())) {
          return d.toLocaleString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })
        }

        // Se nada funcionar, retorna a original
        return date
      } catch (e) {
        return date
      }
    },
    formatMoney(value) {
      if (typeof value !== 'number') {
        value = parseFloat(value)
        if (isNaN(value)) return '-'
      }

      // Se for negativo, formata o valor absoluto e adiciona o sinal depois do R$
      if (value < 0) {
        const formatted = Math.abs(value).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        return formatted.replace('R$', 'R$ -')
      }

      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
  },
}
</script>

<style scoped>
/* Section headers */
.section-header {
    display: flex;
    align-items: center;
    border-bottom: 2px solid #e0e0e0;
    padding-bottom: 8px;
}

.section-title {
    font-size: 1.25rem;
    font-weight: 600;
    color: #424242;
}

/* Timeline customization */
.custom-timeline {
    padding-top: 8px;
}

/* Timeline cards */
.timeline-card {
    border-left: 3px solid currentColor;
    transition: all 0.3s ease;
}

.timeline-card:hover {
    transform: translateX(4px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
}

.timeline-card .v-card__subtitle {
    font-size: 0.875rem;
}

.timeline-card .v-card__text {
    font-size: 0.875rem;
    line-height: 1.6;
}

/* Info rows */
.info-row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding: 4px 0;
}

.info-row:last-child {
    margin-bottom: 0;
}

.info-row .v-icon {
    color: #757575;
}

/* Card text spacing */
.v-card__text p {
    margin-bottom: 4px;
}

.v-card__text p:last-child {
    margin-bottom: 0;
}
</style>
